import axios from 'axios';

import type { Template, TemplatePayload } from '../../@types/types';
import { getRequestAuth } from '../helpers/getRequestAuth';

export const createTemplate = async (data: TemplatePayload, authToken: string): Promise<Pick<Template, 'id'>> => {
  const auth = await getRequestAuth(authToken);

  const response = await axios({
    method: 'post',
    url: `${process.env.REACT_APP_API_URL}/templates-spa-${auth.authProvider}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.token,
    },
    data,
  });

  return response.data;
};
